import * as React from 'react';

import { Label } from 'office-ui-fabric-react/lib/Label';
import { TextField} from 'office-ui-fabric-react/lib/TextField';
import { ChoiceGroup} from 'office-ui-fabric-react/lib/ChoiceGroup';
import { PrimaryButton , DefaultButton } from 'office-ui-fabric-react/lib/Button';

import { Utils } from './classi/Utils.js';
import { Session } from './classi/Session.js';

import './css/BloccaGdpr.css';

const utils = new Utils();
const session = new Session();

export class BloccoGdprEInfo extends React.Component {
    
    constructor() {
        super()
        
        let du = session.get('datiutente');
        
        let GDPRobbligo = utils.getObjInfoSocieta( 'GDPR_OBBLIGO_COMPILA' , '' );
        let GDPRvedi = utils.getObjInfoSocieta( 'VISUALIZZA_FLG_GDPR' , '' );
        let GDPRaccept = utils.getObjInfoSocieta( 'GDPR_VALORI_ACCETTATI' , '' );
        
        let GDPRvedi_terze_parti = utils.getObjInfoSocieta( 'VISUALIZZA_TERZE_PARTI_GDPR' , '' );
        
        let erroreContratto = '';
        if( GDPRobbligo==='SI' && GDPRvedi==='SI' &&  
              ( ( parseInt(du.FLG_GDPR_CONTRATTO,10)===0 && ( typeof GDPRaccept[0] !== 'undefined' ) && GDPRaccept[0].indexOf('NO')===-1 ) || 
                ( parseInt(du.FLG_GDPR_CONTRATTO,10)===1 && ( typeof GDPRaccept[0] !== 'undefined' ) && GDPRaccept[0].indexOf('SI')===-1 ) )
        ){
            erroreContratto = ' erroreGDPR';
        }
        
        let erroreCommerciale = '';
        if( GDPRobbligo==='SI' && GDPRvedi==='SI' &&  
              ( ( parseInt(du.FLG_GDPR_COMMERCIALE,10)===0 && ( typeof GDPRaccept[1] !== 'undefined' ) && GDPRaccept[1].indexOf('NO')===-1 ) || 
                ( parseInt(du.FLG_GDPR_COMMERCIALE,10)===1 && ( typeof GDPRaccept[1] !== 'undefined' ) && GDPRaccept[1].indexOf('SI')===-1 ) )
        ){
            erroreCommerciale = ' erroreGDPR';
        }
        
        let erroreProfilazione = '';
        if( GDPRobbligo==='SI' && GDPRvedi==='SI' && 
              ( ( parseInt(du.FLG_GDPR_POFILAZIONE,10)===0 && ( typeof GDPRaccept[2] !== 'undefined' ) && GDPRaccept[2].indexOf('NO')===-1 ) || 
                ( parseInt(du.FLG_GDPR_POFILAZIONE,10)===1 && ( typeof GDPRaccept[2] !== 'undefined' ) && GDPRaccept[2].indexOf('SI')===-1 ) )
        ){
            erroreProfilazione = ' erroreGDPR';
        }
        
        let erroreInfoprivacy = '';
        if( GDPRobbligo==='SI' && GDPRvedi==='SI' &&  
              ( ( parseInt(du.FLG_GDPR_INFOPRIVACY,10)===0 && ( typeof GDPRaccept[3] !== 'undefined' ) && GDPRaccept[3].indexOf('NO')===-1 ) || 
                ( parseInt(du.FLG_GDPR_INFOPRIVACY,10)===1 && ( typeof GDPRaccept[3] !== 'undefined' ) && GDPRaccept[3].indexOf('SI')===-1 ) )
        ){
            erroreInfoprivacy = ' erroreGDPR';
        }
        
        let erroreTerzeParti = '';
        if( GDPRobbligo==='SI' && GDPRvedi==='SI' && GDPRvedi_terze_parti ==='SI' &&  
              ( ( parseInt(du.FLG_GDPR_TERZE_PARTI,10)===0 && ( typeof GDPRaccept[4] !== 'undefined' ) && GDPRaccept[4].indexOf('NO')===-1 ) || 
                ( parseInt(du.FLG_GDPR_TERZE_PARTI,10)===1 && ( typeof GDPRaccept[4] !== 'undefined' ) && GDPRaccept[4].indexOf('SI')===-1 ) )
        ){
            erroreTerzeParti = ' erroreGDPR';
        }
                
        
        
        this.state = {
            ragsoc:du.RAGIONE_SOCIALE,
            FLG_GDPR_CONTRATTO : parseInt(du.FLG_GDPR_CONTRATTO,10)===1 ? '1' : (parseInt(du.FLG_GDPR_CONTRATTO,10)===0 ? '0' : '' ) ,
            FLG_GDPR_COMMERCIALE : parseInt(du.FLG_GDPR_COMMERCIALE,10)===1 ? '1' : (parseInt(du.FLG_GDPR_COMMERCIALE,10)===0 ? '0' : '' ),
            FLG_GDPR_POFILAZIONE : parseInt(du.FLG_GDPR_POFILAZIONE,10)===1 ? '1' : (parseInt(du.FLG_GDPR_POFILAZIONE,10)===0 ? '0' : '' ),
            FLG_GDPR_INFOPRIVACY : parseInt(du.FLG_GDPR_INFOPRIVACY,10)===1 ? '1' : (parseInt(du.FLG_GDPR_INFOPRIVACY,10)===0 ? '0' : '' ) ,
            FLG_GDPR_TERZE_PARTI : parseInt(du.FLG_GDPR_TERZE_PARTI,10)===1 ? '1' : (parseInt(du.FLG_GDPR_TERZE_PARTI,10)===0 ? '0' : '' ) ,
            txtpopup1 : '<br/>'+utils.getObjInfoSocieta( 'TESTO_POPUP_1' , '' ),
            txtpopup2 : '<br/>'+utils.getObjInfoSocieta( 'TESTO_POPUP_2' , '' ),
            testo:'',
            GDPRvedi_terze_parti : GDPRvedi_terze_parti,
            erroreContratto:erroreContratto,
            erroreCommerciale:erroreCommerciale,
            erroreProfilazione:erroreProfilazione,
            erroreInfoprivacy:erroreInfoprivacy,
            erroreTerzeParti:erroreTerzeParti,
            
            testoAcconsentoTrattamento : '<br/>Acconsento al trattamento dei dati personali:<br/>'
        };
        
        this._onChangeOption = this._onChangeOption.bind(this);
    }

    
    logOut = () => {
        utils.dialogLogout();
    }
    
    inviaForm = () => {
        
        let msgErr = '';
        
        let obblig = utils.getObjInfoSocieta( 'GDPR_VALORI_ACCETTATI' , '' );

        let FLGcont =  document.getElementById( 'FLG_GDPR_CONTRATTO' ).value;
        let FLGcomm =  document.getElementById( 'FLG_GDPR_COMMERCIALE' ).value;
        let FLGprof =  document.getElementById( 'FLG_GDPR_POFILAZIONE' ).value;
        let FLGinfo =  document.getElementById( 'FLG_GDPR_INFOPRIVACY' ).value;
        let FLGterze =  document.getElementById( 'FLG_GDPR_TERZE_PARTI' ).value;
        
        console.log( 'FLGcont' , FLGcont);
        console.log( 'FLGcomm' , FLGcomm);
        console.log( 'FLGprof' , FLGprof);
        console.log( 'FLGinfo' , FLGinfo);
        console.log( 'FLGterze' , FLGterze);
        
        
        if( FLGcont === '' || FLGcomm === '' || FLGprof==='' || FLGinfo==='' || ( FLGterze==='' && this.state.GDPRvedi_terze_parti === 'SI')  ){
            msgErr+= 'Per accedere è obbligatorio compilare tutte le opzioni<br/>';
        }
        
        if( FLGcont === '0' && typeof obblig[0] !== 'undefined' && obblig[0].indexOf('NO') === -1 ){
            msgErr+= 'gestione CONTRATTO : accettato solo valore '+obblig[0].replace('#',' o ')+'<br/>';
        }
        if( FLGcont === '1' && typeof obblig[0] !== 'undefined' && obblig[0].indexOf('SI') === -1 ){
            msgErr+= 'gestione CONTRATTO : accettato solo valore '+obblig[0].replace('#',' o ')+'<br/>';
        }
        
        if( FLGcomm === '0' && typeof obblig[1] !== 'undefined' && obblig[1].indexOf('NO') === -1 ){
            msgErr+= 'gestione COMMERCIALE : accettato solo valore '+obblig[1].replace('#',' o ')+'<br/>';
        }
        if( FLGcomm === '1' && typeof obblig[1] !== 'undefined' && obblig[1].indexOf('SI') === -1 ){
            msgErr+= 'gestione COMMERCIALE : accettato solo valore '+obblig[1].replace('#',' o ')+'<br/>';
        }
        
        if( FLGprof === '0' && typeof obblig[2] !== 'undefined' && obblig[2].indexOf('NO') === -1 ){
            msgErr+= 'gestione PROFILAZIONE : accettato solo valore '+obblig[2].replace('#',' o ')+'<br/>';
        }
        if( FLGprof === '1' && typeof obblig[2] !== 'undefined' && obblig[2].indexOf('SI') === -1 ){
            msgErr+= 'gestione PROFILAZIONE : accettato solo valore '+obblig[2].replace('#',' o ')+'<br/>';
        }
        
        if( FLGinfo === '0' && typeof obblig[3] !== 'undefined' && obblig[3].indexOf('NO') === -1 ){
            msgErr+= 'INFORMATIVA PRIVACY : accettato solo valore '+obblig[3].replace('#',' o ')+'<br/>';
        }
        if( FLGinfo === '1' && typeof obblig[3] !== 'undefined' && obblig[3].indexOf('SI') === -1 ){
            msgErr+= 'INFORMATIVA PRIVACY : accettato solo valore '+obblig[3].replace('#',' o ')+'<br/>';
        }

        if( FLGterze === '0' && typeof obblig[4] !== 'undefined' && obblig[4].indexOf('NO') === -1 ){
            msgErr+= 'gestione TERZE PARTI : accettato solo valore '+obblig[4].replace('#',' o ')+'<br/>';
        }
        if( FLGterze === '1' && typeof obblig[4] !== 'undefined' && obblig[4].indexOf('SI') === -1 ){
            msgErr+= 'gestione TERZE PARTI : accettato solo valore '+obblig[4].replace('#',' o ')+'<br/>';
        }

        if( msgErr !== ''){ this.setState({testo:msgErr}); }
        else {
            // eseguo salvataggio Privacy
            let obj = {};
        
            // per tutti passo id_cliente
            obj['id_cliente'] = session.get('id_cliente');
            obj['tipo_operazione'] = 'privacy';
            
            obj['FLG_GDPR_CONTRATTO'] = FLGcont;
            obj['FLG_GDPR_COMMERCIALE'] = FLGcomm;
            obj['FLG_GDPR_POFILAZIONE'] = FLGprof;
            obj['FLG_GDPR_INFOPRIVACY'] = FLGinfo;
            obj['FLG_GDPR_TERZE_PARTI'] = FLGterze;
            
            utils.inviaPrivacy( obj );
            this.gestisciRisultatoPrivacy( 0 );
        }
    }
    
    gestisciRisultatoPrivacy( count )
    {  
        count++;
        setTimeout( function(){

            var result = utils.leggiRisultatoPrivacy();
            if( count > 50)
            {
                this.setState( {testo: 'Timeout della Richiesta' } );
            }
            else if( result === false )
            {
                this.gestisciRisultatoPrivacy(count);
            }
            else
            {
                if( result.success === true ){ 
                    window.location.reload();
                }
                else {
                    if( 'message' in result && result.message !== ""){ 
                        let msg = result.message;
                        msg=msg.replace(/\n/g, "<br />");
                        this.setState( {testo: msg} );
                    }
                    else { this.setState( {testo: 'Errore Invio Privacy' } ); }
                }
            }
        }.bind(this),500 );
    } 
    
    
    _onChangeOption( event ,option ){
        if( option.id === 'FLG_GDPR_CONTRATTO'){ this.setState({FLG_GDPR_CONTRATTO : option.key }); }
        if( option.id === 'FLG_GDPR_COMMERCIALE'){ this.setState({FLG_GDPR_COMMERCIALE : option.key }); }
        if( option.id === 'FLG_GDPR_POFILAZIONE'){ this.setState({FLG_GDPR_POFILAZIONE : option.key }); }
        if( option.id === 'FLG_GDPR_INFOPRIVACY'){ this.setState({FLG_GDPR_INFOPRIVACY : option.key }); }
        if( option.id === 'FLG_GDPR_TERZE_PARTI'){ this.setState({FLG_GDPR_TERZE_PARTI : option.key }); }
    }
    
    render(){
        return (
            <div id="main-container">
                <div id="ac-container" className="bloccoGDPR">
                    <Label className='ms-fontSize-xxl titolo-pagina'>Privacy</Label>
                    
                    <Label className='ms-fontSize-m ms-fontWeight-semibold'><u>{this.state.ragsoc}</u></Label>
                    
                    <div className='ms-fontSize-s titolo-pagina' dangerouslySetInnerHTML={{__html: this.state.txtpopup1}}></div>
                    
                    <div className='ms-fontSize-s messaggio' dangerouslySetInnerHTML={{__html: this.state.testo}}></div>
                    
                    <div className='editprivacy'>
                    
                        <ChoiceGroup
                            className={'defaultChoiceGroup' + this.state.erroreInfoprivacy }
                            defaultSelectedKey={ parseInt(this.state.FLG_GDPR_INFOPRIVACY,10)===1 ? '1' : (parseInt(this.state.FLG_GDPR_INFOPRIVACY,10)===0 ? '0' : '' )}
                            options={[ { key: '1', text: 'Si', id:'FLG_GDPR_INFOPRIVACY' }, { key: '0', text: 'No', id:'FLG_GDPR_INFOPRIVACY' } ]}
                            onChange={this._onChangeOption}
                            label={utils.getObjInfoSocieta( 'GDPR_INFOPRIVACY_DESC' , '' )}
                            required={false}
                        />
                    
                        <div className='ms-fontSize-m' dangerouslySetInnerHTML={{__html: this.state.testoAcconsentoTrattamento }}></div>
                        
                        <ChoiceGroup
                            className={'defaultChoiceGroup' + this.state.erroreContratto }
                            defaultSelectedKey={ parseInt(this.state.FLG_GDPR_CONTRATTO,10)===1 ? '1' : (parseInt(this.state.FLG_GDPR_CONTRATTO,10)===0 ? '0' : '' )}
                            options={[ { key: '1', text: 'Si', id:'FLG_GDPR_CONTRATTO' }, { key: '0', text: 'No', id:'FLG_GDPR_CONTRATTO' } ]}
                            onChange={this._onChangeOption}
                            label={utils.getObjInfoSocieta( 'GDPR_CONTRATTO_DESC' , '' )}
                            required={false}
                        />

                        <ChoiceGroup
                            className={'defaultChoiceGroup' + this.state.erroreCommerciale }
                            defaultSelectedKey={ parseInt(this.state.FLG_GDPR_COMMERCIALE,10)===1 ? '1' : (parseInt(this.state.FLG_GDPR_COMMERCIALE,10)===0 ? '0' : '' ) }
                            options={[ { key: '1', text: 'Si', id:'FLG_GDPR_COMMERCIALE' }, { key: '0', text: 'No', id:'FLG_GDPR_COMMERCIALE' } ]}
                            onChange={this._onChangeOption}
                            label={utils.getObjInfoSocieta( 'GDPR_COMMERCIALE_DESC' , '' )}
                            required={false}
                        />

                        <ChoiceGroup
                            className={'defaultChoiceGroup' + this.state.erroreProfilazione }
                            defaultSelectedKey={ parseInt(this.state.FLG_GDPR_POFILAZIONE,10)===1 ? '1' : (parseInt(this.state.FLG_GDPR_POFILAZIONE,10)===0 ? '0' : '' )}
                            options={[ { key: '1', text: 'Si', id:'FLG_GDPR_POFILAZIONE' }, { key: '0', text: 'No', id:'FLG_GDPR_POFILAZIONE' } ]}
                            onChange={this._onChangeOption}
                            label={utils.getObjInfoSocieta( 'GDPR_POFILAZIONE_DESC' , '' )}
                            required={false}
                        />
                        
                        <ChoiceGroup
                            className={'defaultChoiceGroup' + ((this.state.GDPRvedi_terze_parti ==='SI') ? this.state.erroreProfilazione : ' nascosto') }
                            defaultSelectedKey={ parseInt(this.state.FLG_GDPR_TERZE_PARTI,10)===1 ? '1' : (parseInt(this.state.FLG_GDPR_TERZE_PARTI,10)===0 ? '0' : '' )}
                            options={[ { key: '1', text: 'Si', id:'FLG_GDPR_TERZE_PARTI' }, { key: '0', text: 'No', id:'FLG_GDPR_TERZE_PARTI' } ]}
                            onChange={this._onChangeOption}
                            label={utils.getObjInfoSocieta( 'GDPR_TERZE_PARTI_DESC' , '' )}
                            required={false}
                        />

                        <TextField  value={ this.state.FLG_GDPR_CONTRATTO }  id='FLG_GDPR_CONTRATTO' className='nascosto' />
                        <TextField  value={ this.state.FLG_GDPR_COMMERCIALE }  id='FLG_GDPR_COMMERCIALE' className='nascosto' />
                        <TextField  value={this.state.FLG_GDPR_POFILAZIONE }  id='FLG_GDPR_POFILAZIONE' className='nascosto' />
                        <TextField  value={this.state.FLG_GDPR_INFOPRIVACY }  id='FLG_GDPR_INFOPRIVACY' className='nascosto' />
                        <TextField  value={this.state.FLG_GDPR_TERZE_PARTI }  id='FLG_GDPR_TERZE_PARTI' className='nascosto' />

                        <div className='bottoni'>
                            <DefaultButton onClick={this.logOut} text="ESCI" />
                            <PrimaryButton onClick={this.inviaForm} text="Salva e Continua" />
                        </div>

                    </div>
                </div>
                <div id="dialogcontainer"></div>
            </div>
            
        );
    }
}

export default BloccoGdprEInfo;


// WEBPACK FOOTER //
// ./src/AcComponents/BloccoGdprEInfo.js